import { render } from "./tagClass.vue?vue&type=template&id=6c463bef"
import script from "./tagClass.vue?vue&type=script&lang=js"
export * from "./tagClass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__